// extracted by mini-css-extract-plugin
export default {"answersList":"Q_c2"};